// extracted by mini-css-extract-plugin
export default {"List":"hq3H3zLPDi_ZmQnrNVQ9"};